import React from 'react';
import { Grid, Paper, makeStyles } from '@material-ui/core';
import ReportsGenerator from 'components/Reports/ReportsGenerator';
import HistoricalReports from 'components/Reports/HistoricalReports';
import { useAppContext } from 'hooks/useAppContext';
import { useAuthContext } from 'hooks/useAuthContext';

const useStyles = makeStyles(theme => ({
    smallCaps: {
        fontVariant: "all-small-caps",
        fontWeight: 400
    },
    generatorForm: {
        marginTop: 4,
        padding: 12
    },
    runReportButtons: {
        marginRight: 80
    },
    dialogContent: {
        overflowY: "unset"
    }
}));

const Reports = () => {
    const classes = useStyles();

    const { selectedProject } = useAppContext();
    const { systemUserId } = useAuthContext();

    return (
        <Grid container justify="center" spacing={2} >
            <Grid item xl={7} lg={12} md={12} sm={12} component={Paper}>
                <ReportsGenerator selectedProject={selectedProject} systemUserId={systemUserId} />
                <HistoricalReports selectedProject={selectedProject} systemUserId={systemUserId} />
            </Grid>
        </Grid>
    )
}


export default Reports;
export { useStyles };